<template>
  <div class="room dehumidifier" v-loading="loadingData">
    <div class="device-block-multi">
      <div class="device-block" :class="warningFlagLeft">
        <div class="device-block-line-chart">
          <DoubleGraph :opts="humidityLeftLineOpts" :series="humidityLeftLineData"></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap :opts="humidityLeftBarOpts" :series="humidityLeftBarData"></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="device-block" :class="warningFlagRight">
        <div class="device-block-line-chart">
          <DoubleGraph :opts="humidityRightLineOpts" :series="humidityRightLineData"></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap :opts="humidityRightBarOpts" :series="humidityRightBarData"></SinglePieHistogramWrap>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleLeft1" :series="switchDataLeft1"></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleLeft2" :series="switchDataLeft2"></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig
          class="device-block-time"
          :title="runningTimeTitleLeft"
          :series="runningTimeDataLeft"
        ></RunningTimeBig>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleRight1" :series="switchDataRight1"></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleRight2" :series="switchDataRight2"></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig
          class="device-block-time"
          :title="runningTimeTitleRight"
          :series="runningTimeDataRight"
        ></RunningTimeBig>
      </div>

      <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    </div>
  </div>
</template>

<script>
import configJson from './config/dehumidifierTowerConfig.json';

export default {
  name: 'dehumidifierSmall',
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: '',
      warningFlagLeft: '',
      warningFlagRight: '',
      deviceList: [],
      bridgeSegmentName: '',
      deviceLeftName: '',
      deviceRightName: '',
      humidityLeftLineData: null,
      humidityLeftBarData: null,
      humidityRightLineData: null,
      humidityRightBarData: null,
      switchDataLeft1: null,
      switchDataLeft2: null,
      switchDataRight1: null,
      switchDataRight2: null,
      runningTimeDataLeft: null,
      runningTimeDataRight: null
    };
  },
  computed: {
    humidityLeftLineOpts: function() {
      return {
        title: this.bridgeSegmentName + this.deviceLeftName + '温湿度',
        legend1: '湿度',
        legend2: '温度'
      };
    },
    humidityRightLineOpts: function() {
      return {
        title: this.bridgeSegmentName + this.deviceRightName + '温湿度',
        legend1: '湿度',
        legend2: '温度'
      };
    },
    humidityLeftBarOpts: function() {
      return {
        title: this.deviceLeftName + '温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      };
    },
    humidityRightBarOpts: function() {
      return {
        title: this.deviceRightName + '温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      };
    },
    switchTitleLeft1: function() {
      return this.deviceLeftName + '运行';
    },
    switchTitleLeft2: function() {
      return this.deviceLeftName + '故障';
    },
    runningTimeTitleLeft: function() {
      return this.deviceLeftName + '运行时间';
    },
    switchTitleRight1: function() {
      return this.deviceRightName + '运行';
    },
    switchTitleRight2: function() {
      return this.deviceRightName + '故障';
    },
    runningTimeTitleRight: function() {
      return this.deviceRightName + '运行时间';
    }
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    }
  },
  methods: {
    resetData() {
      this.warningFlagLeft = '';
      this.warningFlagRight = '';
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split('/');
      this.deviceList = configJson[routerPath[3]].deviceList;
      const deviceName = configJson[routerPath[3]].deviceName;
      this.deviceLeftName = deviceName.deviceLeftName;
      this.deviceRightName = deviceName.deviceRightName;
      this.stationId = configJson[routerPath[3]].stationId;
      this.bridgeSegmentName = configJson[routerPath[3]].bridgeSegmentName;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || '';
    },
    getStatisticsData(deviceId) {
      return this.$http.get(
        '/statistics/DeviceData?deviceId=' +
          deviceId +
          '&interval=BY_HOUR&insertBlankData=true'
      );
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getLineChartData();

      this.getCurrentData(this.stationId).then(res => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;

        this.setPieHistogramDataAndError(
          currentData,
          'humidityLeftBarData',
          this.deviceLeftName + '温度',
          this.deviceLeftName + '湿度',
          'warningFlagLeft'
        );
        this.setPieHistogramDataAndError(
          currentData,
          'humidityRightBarData',
          this.deviceRightName + '温度',
          this.deviceRightName + '湿度',
          'warningFlagRight'
        );

        const switchIdLeft1 = this.findDeviceId(this.deviceLeftName + '运行');
        const switchIdLeft2 = this.findDeviceId(this.deviceLeftName + '故障');
        this.switchDataLeft1 = {
          data: currentData[switchIdLeft1].value,
          isError: currentData[switchIdLeft1].errorLevel
        };
        this.switchDataLeft2 = {
          data: currentData[switchIdLeft2].value,
          isError: currentData[switchIdLeft2].errorLevel,
          isZh: true
        };


        const switchIdRight1 = this.findDeviceId(
          this.deviceRightName + '运行'
        );
        const switchIdRight2 = this.findDeviceId(
          this.deviceRightName + '故障'
        );
        this.switchDataRight1 = {
          data: currentData[switchIdRight1].value,
          isError: currentData[switchIdRight1].errorLevel
        };
        this.switchDataRight2 = {
          data: currentData[switchIdRight2].value,
          isError: currentData[switchIdRight2].errorLevel,
          isZh: true
        };


        const runningTimeIdLeft = this.findDeviceId(
          this.deviceLeftName + '运行时间'
        );
        this.runningTimeDataLeft = currentData[runningTimeIdLeft].value * 60;

        const runningTimeIdRight = this.findDeviceId(
          this.deviceRightName + '运行时间'
        );
        this.runningTimeDataRight = currentData[runningTimeIdRight].value * 60;
      });
    },

    setPieHistogramDataAndError(
      currentData,
      echartSeriesDataName,
      temperatureName,
      humidityName,
      warningFlagName
    ) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[temperatureId].errorLevel,
        this[warningFlagName]
      );
      errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[humidityId].errorLevel,
        this[warningFlagName]
      );
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = this.deviceLeftName + '温度';
      let humidityDeviceName = this.deviceLeftName + '湿度';
      this.$http
        .all([
          this.getStatisticsData(this.findDeviceId(temperatureDeviceName)),
          this.getStatisticsData(this.findDeviceId(humidityDeviceName))
        ])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(
              temperaturePromise,
              humidityPromise,
              'humidityLeftLineData',
              'warningFlagLeft'
            );
          })
        );

      temperatureDeviceName = this.deviceRightName + '温度';
      humidityDeviceName = this.deviceRightName + '湿度';
      this.$http
        .all([
          this.getStatisticsData(this.findDeviceId(temperatureDeviceName)),
          this.getStatisticsData(this.findDeviceId(humidityDeviceName))
        ])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(
              temperaturePromise,
              humidityPromise,
              'humidityRightLineData',
              'warningFlagRight'
            );
          })
        );
    },
    setLineData(
      temperatureData,
      humidityData,
      echartSeriesDataName,
      warningFlagName
    ) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(
        temperatureData.data.errorLevel,
        this[warningFlagName]
      );
      errorLevel = this.getErrorLevelFromMultipleDevice(
        humidityData.data.errorLevel,
        this[warningFlagName]
      );
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === 'Error') {
        return 'Error';
      } else if (currentErrorLevel === 'Warning') {
        if (newErrorLevel === 'Error') {
          return 'Error';
        } else {
          return 'Warning';
        }
      } else {
        return newErrorLevel;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dehumidifier {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 10px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .device-block-time {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
